import * as React from "react";
import type { SVGProps } from "react";
const SvgChevronDownExtraSmall = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M12 14.25a1 1 0 0 1-.63-.22l-4-3.25a.999.999 0 0 1 .913-1.753 1 1 0 0 1 .347.203L12 11.97l3.37-2.74a1 1 0 1 1 1.26 1.55l-4 3.25a1 1 0 0 1-.63.22"
    />
  </svg>
);
export default SvgChevronDownExtraSmall;
